import React, { useEffect, useState } from "react";

import { Navigate, useNavigate, useOutlet, useParams } from "react-router-dom";
import styled from "styled-components";

import { v4 as uuidv4 } from "uuid";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";
import ApiController from "../controller/ApiController";
import { APP_TYPE } from "../utils/DataType";
import { qrAuthState, qrAuthType } from "../recoil/auth";
import { useRecoilState } from "recoil";
import toast from "react-hot-toast";
import moment from "moment";
import { useQueryClient } from "@tanstack/react-query";
import { orderDetailRealmType } from "../recoil/type";
import { cartState } from "../recoil/cart";

export const MobileLogin = () => {
  const outlet = useOutlet();
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const { hotel_id, area_id, room_id } = useParams();
  const [auth, setAuth] = useRecoilState<qrAuthType>(qrAuthState);
  const [cart, setCart] = useRecoilState<orderDetailRealmType[]>(cartState);
  const [uuid, setUuid] = useState<string>(AsyncLocalStorage.getItem("uuid"));

  const qrLogin = async () => {
    let response = await ApiController.auth.signinClient({
      device_uuid: uuid,
      app_type: APP_TYPE.KNOCK,
    });

    if (
      response.data === undefined ||
      response.data.ok === false ||
      response.data.data === undefined
    ) {
      return false;
    }

    let loginInfo: any = response.data.data;
    const qrLogin: qrAuthType = {
      user_token_id: loginInfo.user_token_id,
      device_id: loginInfo.device_id,
      device_name: loginInfo.device_id,
      is_main: loginInfo.is_main,
      refresh_token: loginInfo.refresh_token,
      client_user_id: loginInfo.client_user_id,
      phone_number: loginInfo.phone_number ? loginInfo.phone_number : null,
      user_id: Number(hotel_id),
      area_id: Number(area_id),
      room_id: Number(room_id),
      expired_data: moment().add(3, "hours").format("YYYY-MM-DD HH:mm:ss"),
    };
    console.log("mobile uuid", qrLogin);

    await AsyncLocalStorage.setItem("qrAuth", JSON.stringify(qrLogin));
    await AsyncLocalStorage.setItem("initialFlag", JSON.stringify(true));
    await AsyncLocalStorage.setItem("guideFlag", JSON.stringify(true));
    setAuth(qrLogin);
    console.log("login");
  };

  const qrUpdate = async () => {
    const qrLogin: qrAuthType = {
      ...auth,
      user_id: Number(hotel_id),
      area_id: Number(area_id),
      room_id: Number(room_id),
      expired_data: moment().add(3, "hours").format("YYYY-MM-DD HH:mm:ss"),
    };
    queryClient.invalidateQueries({ queryKey: ["store-list"] });
    AsyncLocalStorage.removeItem("cart");
    setCart([]);
    await AsyncLocalStorage.setItem("qrAuth", JSON.stringify(qrLogin));
    await AsyncLocalStorage.setItem("initialFlag", JSON.stringify(true));
    await AsyncLocalStorage.setItem("guideFlag", JSON.stringify(true));
    setAuth(qrLogin);
    console.log("update");
  };

  const checkUuid = async () => {
    console.log("uuid", uuid);
    if (uuid && uuid !== "") {
      if (
        auth.refresh_token === "" ||
        auth.expired_data === null ||
        new Date(auth.expired_data).getTime() <= new Date().getTime()
      ) {
        qrLogin();
      } else if (
        auth.user_id !== Number(hotel_id) ||
        auth.area_id !== Number(area_id) ||
        auth.room_id !== Number(room_id)
      ) {
        qrUpdate();
      } else {
        navigate("/master", { replace: true });
      }
    } else {
      const newId = JSON.stringify(uuidv4());
      await AsyncLocalStorage.setItem("uuid", newId);
      setUuid(newId);
    }
  };

  useEffect(() => {
    checkUuid();
  }, [uuid, auth]);

  return (
    <Style>
      <div className="screen">{outlet}</div>
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }
`;
